module.exports = __webpack_public_path__ + "static/media/kaporg-icon.65251e2e.svg";